// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SharedAudioPlayer__container-cb2823 {
  display: flex;
  padding: 12px var(--padding);
  align-items: center;
}

.SharedAudioPlayer__icon-f0c744 {
  cursor: pointer;
  margin-inline-end: 8px;
}

.SharedAudioPlayer__title-c4b97a {
  color: var(--base-110);
  font: var(--font-body-2);
  letter-spacing: var(--font-spacing-body-2);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}`, "",{"version":3,"sources":["webpack://./src/components/AudioPlayer/SharedAudioPlayer/SharedAudioPlayer.styles.m.css"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,4BAAA;EACA,mBAAA;AACF;;AAEA;EACE,eAAA;EACA,sBAAA;AACF;;AAEA;EACE,sBAAA;EACA,wBAAA;EACA,0CAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AACF","sourcesContent":[".container {\n  display: flex;\n  padding: 12px var(--padding);\n  align-items: center;\n}\n\n.icon {\n  cursor: pointer;\n  margin-inline-end: 8px;\n}\n\n.title {\n  color: var(--base-110);\n  font: var(--font-body-2);\n  letter-spacing: var(--font-spacing-body-2);\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `SharedAudioPlayer__container-cb2823`,
	"icon": `SharedAudioPlayer__icon-f0c744`,
	"title": `SharedAudioPlayer__title-c4b97a`
};
module.exports = ___CSS_LOADER_EXPORT___;
